<div class="chart-container">
    <canvas id="chart"></canvas>
</div>